import { icon } from "../lib/icons";

const HOURS = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

export function scheduleHTML(): string {
  return `
<div class="schedule">
  <div class="sched-toolbar">
    <div class="filters">
      <span class="filter-label">${icon("filter", 13)} Filter</span>
      ${filterGroupAircraft()}
      ${filterGroupInstructor()}
    </div>
    <div class="sched-toolbar-right">
      <div class="seg">
        <button :class="$store.board.scheduleView === 'timeline' ? 'on' : ''"
          @click="$store.board.scheduleView = 'timeline'">Timeline</button>
        <button :class="$store.board.scheduleView === 'list' ? 'on' : ''"
          @click="$store.board.scheduleView = 'list'">List</button>
      </div>
      <button class="btn btn-primary btn-sm"
        x-show="$store.board.role === 'Owner' || $store.board.role === 'Scheduler'"
        @click="$store.ui.openNew()">
        ${icon("plus", 13)} New booking
      </button>
    </div>
  </div>

  <div class="sched-tip"
    x-show="!$store.ui.scheduleTipDismissed && ($store.board.role === 'Owner' || $store.board.role === 'Scheduler')">
    <span class="muted">Tip · click + drag on an empty slot to create a booking · right-click for instant new</span>
    <button type="button" class="btn-icon btn btn-ghost" aria-label="Dismiss tip"
      @click="$store.ui.dismissScheduleTip()">${icon("x", 12)}</button>
  </div>

  <div x-show="$store.board.scheduleView === 'timeline'">
    ${timelineHTML()}
  </div>
  <div x-show="$store.board.scheduleView === 'list'">
    ${listHTML()}
  </div>
</div>
`;
}

function filterGroupAircraft(): string {
  return `
    <div class="fg">
      <span class="fg-label">Aircraft</span>
      <div class="fg-chips">
        <button class="filter-chip"
          :class="$store.board.filterAircraft === 'all' ? 'on' : ''"
          @click="$store.board.filterAircraft = 'all'">All</button>
        <template x-for="a in $store.board.lookups.aircraft" :key="a.id">
          <button class="filter-chip"
            :class="$store.board.filterAircraft === a.id ? 'on' : ''"
            @click="$store.board.filterAircraft = a.id"
            x-text="a.tail"></button>
        </template>
      </div>
    </div>
  `;
}

function filterGroupInstructor(): string {
  return `
    <div class="fg">
      <span class="fg-label">Instructor</span>
      <div class="fg-chips">
        <button class="filter-chip"
          :class="$store.board.filterInstructor === 'all' ? 'on' : ''"
          @click="$store.board.filterInstructor = 'all'">All</button>
        <template x-for="u in $store.board.lookups.profiles.filter(p => p.role.includes('Instructor'))" :key="u.id">
          <button class="filter-chip"
            :class="$store.board.filterInstructor === u.id ? 'on' : ''"
            @click="$store.board.filterInstructor = u.id"
            x-text="(() => { const parts = u.name.split(' '); return parts.length >= 2 ? parts[0] + ' ' + parts[1][0] + '.' : u.name; })()"></button>
        </template>
      </div>
    </div>
  `;
}

function gridHandlers(aircraftIdExpr: string): string {
  return `
    @pointerdown="onPointerDown($event, ${aircraftIdExpr})"
    @pointermove="onPointerMove($event)"
    @pointerup="onPointerUp($event, ${aircraftIdExpr})"
    @pointercancel="onPointerCancel()"
    @contextmenu="onContextMenu($event, ${aircraftIdExpr})"
    :style="($store.board.role === 'Owner' || $store.board.role === 'Scheduler') ? 'cursor: crosshair' : ''"
  `;
}

function ghostBlockHTML(): string {
  return `
    <div class="tl-block"
      style="background: var(--brand-100); border: 1.5px dashed var(--brand-500); pointer-events: none; opacity: 0.85"
      :style="\`left: \${ghostLeftPct()}%; width: \${ghostWidthPct()}%\`">
      <div class="tl-block-top">
        <span class="tl-block-time mono" x-text="ghostLabel()"></span>
      </div>
      <div class="tl-block-title">New booking</div>
    </div>
  `;
}

function timelineHTML(): string {
  return `
    <div class="timeline-card card" x-data="schedule()">
      <div class="tl-header">
        <div class="tl-tail-col"><span class="muted small">Aircraft</span></div>
        <div class="tl-grid-h">
          ${HOURS.map(h => `<div class="tl-tick"><span class="mono">${String(h).padStart(2,"0")}:00</span></div>`).join("")}
          <div class="tl-now" :style="\`left: \${nowPct}%\`">
            <div class="tl-now-label mono" x-text="nowLabel"></div>
          </div>
        </div>
      </div>

      <template x-for="ac in aircraftRows" :key="ac.id">
        <div class="tl-row">
          <div class="tl-tail-col">
            <div class="tl-ac">
              <span class="mono ac-tail" x-text="ac.tail"></span>
              <span class="dim mono ac-model" x-text="ac.model"></span>
            </div>
            <div class="tl-ac-state">
              <template x-if="ac.state === 'maintenance'">
                <span class="chip warning"><span class="chip-dot"></span><span x-text="\`maint due \${ac.maintenanceDueDays}d\`"></span></span>
              </template>
              <template x-if="ac.state === 'dispatched'">
                <span class="chip airborne"><span class="chip-dot"></span>dispatched</span>
              </template>
              <template x-if="ac.state === 'available'">
                <span class="chip ready"><span class="chip-dot"></span>available</span>
              </template>
            </div>
          </div>
          <div class="tl-grid" ${gridHandlers("ac.id")}>
            ${HOURS.map(() => `<div class="tl-cell"></div>`).join("")}
            <div class="tl-now-line" :style="\`left: \${nowPct}%\`"></div>
            <template x-for="b in bookingsFor(ac.id)" :key="b.id">
              ${blockTemplate()}
            </template>
            <template x-if="isGhostFor(ac.id)">
              ${ghostBlockHTML()}
            </template>
          </div>
        </div>
      </template>

      <div class="tl-row" x-show="showClassroom">
        <div class="tl-tail-col">
          <div class="tl-ac">
            <span class="mono ac-tail">CLASS-A</span>
            <span class="dim mono ac-model">Classroom</span>
          </div>
        </div>
        <div class="tl-grid" ${gridHandlers("null")}>
          ${HOURS.map(() => `<div class="tl-cell"></div>`).join("")}
          <div class="tl-now-line" :style="\`left: \${nowPct}%\`"></div>
          <template x-for="b in classroomBookings()" :key="b.id">
            ${blockTemplate()}
          </template>
          <template x-if="isGhostFor(null)">
            ${ghostBlockHTML()}
          </template>
        </div>
      </div>
    </div>
  `;
}

function blockTemplate(): string {
  return `
    <button class="tl-block"
      :class="\`\${b.status} \${blockHasWarn(b) ? 'warn' : ''}\`"
      :style="\`left: \${pos(b.start)}%; width: \${w(b.start, b.end)}%\`"
      :title="\`\${lessonName(b.lessonId)} · \${studentLabel(b.studentId)} · \${b.start}–\${b.end}\`"
      @click.stop="$store.ui.openView(b)"
      @pointerdown.stop>
      <div class="tl-block-top">
        <span class="tl-block-time mono" x-text="\`\${b.start}–\${b.end}\`"></span>
        <span x-show="blockHasWarn(b)" class="tl-block-warn">${icon("warn", 11)}</span>
      </div>
      <div class="tl-block-title" x-text="lessonName(b.lessonId)"></div>
      <div class="tl-block-meta mono" x-text="metaLine(b)"></div>
    </button>
  `;
}

function listHTML(): string {
  return `
    <div class="card list-card" x-data="schedule()">
      <table class="tbl">
        <thead>
          <tr>
            <th scope="col">Time</th>
            <th scope="col">Lesson</th>
            <th scope="col">Student</th>
            <th scope="col">Instructor</th>
            <th scope="col">Aircraft</th>
            <th scope="col">Status</th>
            <th scope="col">Warnings</th>
            <th scope="col"><span class="sr-only">Open booking</span></th>
          </tr>
        </thead>
        <tbody>
          <template x-if="visibleBookings().length === 0">
            <tr><td colspan="8" style="text-align: center; padding: 32px" class="muted">
              No bookings match the current filter.
            </td></tr>
          </template>
          <template x-for="b in visibleBookings()" :key="b.id">
            <tr :class="blockHasWarn(b) ? 'row-warn' : ''" style="cursor: pointer"
              role="button" tabindex="0"
              :aria-label="\`Open booking \${lessonName(b.lessonId)} \${b.start} to \${b.end}\`"
              @click="$store.ui.openView(b)"
              @keydown.enter.prevent="$store.ui.openView(b)"
              @keydown.space.prevent="$store.ui.openView(b)">
              <td class="mono tnum" :class="blockHasWarn(b) ? 'warn-cell' : ''" x-text="\`\${b.start}–\${b.end}\`"></td>
              <td><strong x-text="lessonName(b.lessonId)"></strong></td>
              <td><span x-html="userChipHTML(b.studentId)"></span></td>
              <td><span x-html="userChipHTML(b.instructorId)"></span></td>
              <td class="mono" x-text="aircraftLabel(b.aircraftId)"></td>
              <td>
                <span class="chip" :class="b.status">
                  <span class="chip-dot"></span><span x-text="statusLabel(b)"></span>
                </span>
              </td>
              <td>
                <template x-if="blockHasWarn(b)">
                  <span class="chip warning"><span class="chip-dot"></span><span x-text="warnCount(b)"></span></span>
                </template>
                <template x-if="!blockHasWarn(b)">
                  <span class="dim" aria-hidden="true">—</span>
                </template>
              </td>
              <td aria-hidden="true">${icon("chevron", 14)}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  `;
}
